module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.ee2bb9f3.eot";